import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LockKey } from "@phosphor-icons/react";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";
import SEO from "../../components/SEO";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      const msg = formatApiErrorDetail(err.response?.data?.detail) || err.message;
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-os-bg text-white grain flex items-center justify-center px-5 relative">
      <SEO title="Admin Login" description="Eazymuv admin panel" />
      <div className="absolute inset-0 grid-bg-dark opacity-30" />
      <div className="relative w-full max-w-md border border-white/15 bg-os-bg" data-testid="admin-login">
        <div className="border-b border-white/15 px-8 py-6">
          <img src="/eazymuv-logo.jpeg" alt="Eazymuv" className="h-9 w-auto" />
          <div className="font-mono-ez text-xs text-white/40 mt-3">Admin · Content management</div>
        </div>
        <form onSubmit={submit} className="p-8 space-y-5">
          <div>
            <label className="block text-[11px] font-mono-ez uppercase tracking-wider text-white/50 mb-1">Email</label>
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-white/5 border border-white/20 px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-ez-yellow ring-inset" />
          </div>
          <div>
            <label className="block text-[11px] font-mono-ez uppercase tracking-wider text-white/50 mb-1">Password</label>
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-white/5 border border-white/20 px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-ez-yellow ring-inset" />
          </div>
          {error && <div className="text-red-400 text-sm" data-testid="login-error">{error}</div>}
          <button type="submit" disabled={loading} data-testid="login-submit" className="w-full flex items-center justify-center gap-2 bg-ez-yellow text-ez-text py-3 font-semibold hover:bg-white transition-colors disabled:opacity-50">
            <LockKey size={16} weight="bold" /> {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
